import {faCheck, faTimes} from '@fortawesome/pro-light-svg-icons'

import {FaIcon} from '../../FaIcon'
import {Footnote} from '../../Footnote'
import {EmissionSvg} from './EmissionSvg'
import {Tag} from '../../Tag'
import {useInlineDisclaimerStore} from '../../../stores'

import type {PropsWithChildren} from 'react'

export interface SpanProps extends PropsWithChildren {
  'data-footnote'?: string
  'data-no-break'?: string
  'data-text-medium'?: string
  'data-icon'?: 'check' | 'times' | 'euro-2' | 'euro-3' | 'euro-4'
}

export const Span = (props: SpanProps) => {
  const identifier = props['data-footnote']?.toString() // ensure no number will pass as identifier
  const iconKey = props['data-icon']

  const {findInlineDisclaimer} = useInlineDisclaimerStore()

  if (iconKey) {
    if (iconKey === 'check') return <FaIcon icon={faCheck} />
    if (iconKey === 'times') return <FaIcon icon={faTimes} />
    if (iconKey === 'euro-2') return <EmissionSvg>2</EmissionSvg>
    if (iconKey === 'euro-3') return <EmissionSvg fill={'#f1ca01'}>3</EmissionSvg>
    if (iconKey === 'euro-4') return <EmissionSvg fill={'#008351'}>4</EmissionSvg>
  }

  if (identifier) {
    const inlineDisclaimer = findInlineDisclaimer(identifier)

    if (inlineDisclaimer?.__typename === 'XCRectangleFootnoteType') {
      return (
        <Tag
          identifier={identifier}
          {...inlineDisclaimer}
        />
      )
    }
    if (inlineDisclaimer?.__typename === 'XCInfoFootnoteType') {
      return (
        <Footnote identifier={identifier}>{props.children}</Footnote>
      )
    }
  }

  return (
    <span
      data-testid={'_span'}
      {...props}
    />
  )
}
